export const createSMSCRate = (builder) => ({
    createSMSCRate: builder.mutation({
        query: (body) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: '/smsc_rate',
                method: 'POST',
                body: body,
                headers: {
                    'Authorization': token
                },
            };
        },
    }),
});

